import React, { useState, useEffect } from 'react';
import { db } from '../config/firebase';
import {
  collection,
  query,
  where,
  getDocs,
  addDoc,
  updateDoc,
  deleteDoc,
  doc,
} from 'firebase/firestore';
import Modal from 'react-modal';

import jsPDF from 'jspdf';
import 'jspdf-autotable';
import ExcelJS from 'exceljs';

import { saveAs } from 'file-saver';
import { FaDownload, FaEdit, FaTrash } from 'react-icons/fa';
import ReportModal from './ReportModal';
import Tooltip from './Tooltip';
import { addLegacyFinancialAliases, toNumber } from '../utils/obracunFields';
import {
  computeAutoAdditionsFromHours,
  computeFeeTotals,
  computeMonthlyHourSummary,
  computeTotal2,
} from '../utils/obracunCalculator';
import { validateEarningRecord } from '../utils/earningsValidation';
import '../css/PersonRow.css';

function PersonRow({
  person,
  earningsData,
  numOfWeeks,
  startWeek,
  selectedYear,
  selectedMonth,
  userPeriodData,
  onUpdatePerson,
  refreshData,
  firms = [],
  dailyMetricsData = [],
  monthlyNightHoursMap = {},
  holidaysByDate = {},
  obracunRates = { sunday: 0, holiday: 0, overtime: 0, night: 0 },
  hiddenColumns = {
    glovoId: false,
    woltId: false,
    vozilo: true,
    registracija: true,
    vlasnik: true,
    firma: false,
    zaradaTotal: false,
    fee: false,
    feeIznos: false,
    total1: false,
    tax: false,
    rent: false,
    petrol: false,
    acom: false,
    utility: false,
    sim: false,
    advance: false,
    nedelja: false,
    praznici: false,
    prekovremeno: false,
    nocniSati: false,
    ostalo: false,
    bonus: false,
    total2: false,
  },
}) {
  const [isPersonModalOpen, setIsPersonModalOpen] = useState(false);
  const [isFinancialModalOpen, setIsFinancialModalOpen] = useState(false);
  const [isReportModalOpen, setIsReportModalOpen] = useState(false);
  const [isEarningsModalOpen, setIsEarningsModalOpen] = useState(false);

  const [startMonth, setStartMonth] = useState(person.startMonth || new Date().getMonth() + 1);
  const [startYear, setStartYear] = useState(person.startYear || new Date().getFullYear());
  const [isRowSelected, setIsRowSelected] = useState(false);

  const [name, setName] = useState(person.name);
  const [city, setCity] = useState(person.city || '');
  const [comment, setComment] = useState(person.comment || '');
  const [tekuciRacun, setTekuciRacun] = useState(person.tekuciRacun || '');
  const [zasticeniRacun, setZasticeniRacun] = useState(person.zasticeniRacun || '');
  const [iban, setIban] = useState(person.iban || '');
  const [glovoId, setGlovoId] = useState((person.glovoId || person.riderID || '').trim().toLowerCase());
  const [woltId, setWoltId] = useState((person.woltId || '').trim().toLowerCase());
  const [vozilo, setVozilo] = useState(person.vozilo || '');
  const [vlasnik, setVlasnik] = useState(person.vlasnik || '');
  const [registracija, setRegistracija] = useState(person.registracija || '');
  const [firmId, setFirmId] = useState(person.firmId || 'default');
  const [email, setEmail] = useState(person.email || 'nema');
  const [appKnjigDefault, setAppKnjigDefault] = useState(person.appKnjig || 0);
  const [doprinosiDefault, setDoprinosiDefault] = useState(person.doprinosi || 0);
  const [feeDefault, setFeeDefault] = useState(person.fee || 0);

  const [fee, setFee] = useState(
    userPeriodData.fee !== undefined ? userPeriodData.fee : person.fee || 0
  );
  const [appKnjig, setAppKnjig] = useState(
    userPeriodData.appKnjig !== undefined ? userPeriodData.appKnjig : person.appKnjig || 0
  );
  const [doprinosi, setDoprinosi] = useState(
    userPeriodData.doprinosi !== undefined ? userPeriodData.doprinosi : person.doprinosi || 0
  );
  const [renta, setRenta] = useState(
    userPeriodData.renta !== undefined ? userPeriodData.renta : person.renta || 0
  );
  const [rentSmjestaj, setRentSmjestaj] = useState(
    userPeriodData.rentSmjestaj !== undefined ? userPeriodData.rentSmjestaj : person.rentSmjestaj || 0
  );
  const [oprema, setOprema] = useState(
    userPeriodData.oprema !== undefined ? userPeriodData.oprema : person.oprema || 0
  );
  const [akontacija, setAkontacija] = useState(
    userPeriodData.akontacija !== undefined ? userPeriodData.akontacija : person.akontacija || 0
  );
  const [gorivo, setGorivo] = useState(
    userPeriodData.gorivo !== undefined ? userPeriodData.gorivo : person.gorivo || 0
  );
  const [ostalo, setOstalo] = useState(
    userPeriodData.ostalo !== undefined ? userPeriodData.ostalo : person.ostalo || 0
  );
  const [bonus, setBonus] = useState(
    userPeriodData.bonus !== undefined ? userPeriodData.bonus : person.bonus || 0
  );
  const [tarifa, setTarifa] = useState(
    userPeriodData.tarifa !== undefined ? userPeriodData.tarifa : person.tarifa || 0
  );
  const [depozit, setDepozit] = useState(
    userPeriodData.depozit !== undefined ? userPeriodData.depozit : person.depozit || 0
  );
  const [struja, setStruja] = useState(
    userPeriodData.struja !== undefined ? userPeriodData.struja : person.struja || 0
  );
  const [glovoTax, setGlovoTax] = useState(
    userPeriodData.glovoTax !== undefined ? userPeriodData.glovoTax : person.glovoTax || 0
  );
  const [napomena, setNapomena] = useState(userPeriodData.napomena || '');

  const [rentaDefault, setRentaDefault] = useState(person.renta || 0);
  const [rentSmjestajDefault, setRentSmjestajDefault] = useState(person.rentSmjestaj || 0);
  const [opremaDefault, setOpremaDefault] = useState(person.oprema || 0);
  const [akontacijaDefault, setAkontacijaDefault] = useState(person.akontacija || 0);
  const [gorivoDefault, setGorivoDefault] = useState(person.gorivo || 0);
  const [ostaloDefault, setOstaloDefault] = useState(person.ostalo || 0);
  const [bonusDefault, setBonusDefault] = useState(person.bonus || 0);
  const [tarifaDefault, setTarifaDefault] = useState(person.tarifa || 0);
  const [depozitDefault, setDepozitDefault] = useState(person.depozit || 0);
  const [strujaDefault, setStrujaDefault] = useState(person.struja || 0);
  const [glovoTaxDefault, setGlovoTaxDefault] = useState(person.glovoTax || 0);

  const [earnings, setEarnings] = useState([]);
  const [woltEarnings, setWoltEarnings] = useState([0, 0]); // W1 i W2
  const [editedWeeks, setEditedWeeks] = useState(new Array(numOfWeeks).fill(false));
  const [editedWoltWeeks, setEditedWoltWeeks] = useState([false, false]); // Za W1 i W2
  const [feeAmount, setFeeAmount] = useState((0).toFixed(2));

  useEffect(() => {
    const earningsArray = new Array(numOfWeeks).fill(0);
    const woltArray = [0, 0]; // W1 i W2

    earningsData.forEach((earning) => {
      if (earning.userId === person.id &&
          earning.year === selectedYear &&
          earning.month === selectedMonth) {
        // Provjera je li to Wolt zarada
        const isWolt = earning.platform === 'wolt' || earning.week === 'w1' || earning.week === 'w2';
        
        const amt = parseFloat(earning.amount) || 0;
        if (isWolt) {
          if (earning.week === 'w1') woltArray[0] += amt;
          else if (earning.week === 'w2') woltArray[1] += amt;
        } else {
          const weekIndex = earning.week - startWeek;
          if (weekIndex >= 0 && weekIndex < numOfWeeks) {
            earningsArray[weekIndex] += amt;
          }
        }
      }
    });

    setEarnings(earningsArray);
    setWoltEarnings(woltArray);
  }, [earningsData, person.id, numOfWeeks, startWeek, selectedYear, selectedMonth]);

  // ZaradaTotal uključuje i Glovo i Wolt zarade
  const glovoTotal = earnings.reduce((sum, earning) => sum + earning, 0);
  const woltTotal = woltEarnings.reduce((sum, earning) => sum + earning, 0);
  const zaradaTotal = glovoTotal + woltTotal;
  const { feeIznos, total1 } = computeFeeTotals(zaradaTotal, fee);
  const calculatedFeeAmount = feeIznos.toFixed(2);

  const monthlyHoursSummary = computeMonthlyHourSummary(
    person.id,
    selectedYear,
    selectedMonth,
    dailyMetricsData,
    holidaysByDate,
    monthlyNightHoursMap
  );
  const autoAmounts = computeAutoAdditionsFromHours(monthlyHoursSummary, obracunRates);
  const monthlyDistanceKm = dailyMetricsData
    .filter((d) => d.userId === person.id && d.year === selectedYear && d.month === selectedMonth)
    .reduce((sum, d) => {
      const glovoMeters = parseFloat(d.glovoDistanceMeters ?? 0) || 0;
      const woltMeters = parseFloat(d.woltDistanceMeters ?? 0) || 0;
      return sum + glovoMeters + woltMeters;
    }, 0) / 1000;
  const total2 = computeTotal2({
    total1,
    tax: glovoTax,
    rent: renta,
    petrol: gorivo,
    acom: appKnjig,
    utility: struja,
    sim: doprinosi,
    advance: akontacija,
    sunday: autoAmounts.sunday,
    holiday: autoAmounts.holiday,
    overtime: autoAmounts.overtime,
    night: autoAmounts.night,
    bonus,
    ostalo,
  }).toFixed(2);

  useEffect(() => {
    setName(person.name);
    setCity(person.city || '');
    setComment(person.comment || '');
    setTekuciRacun(person.tekuciRacun || '');
    setZasticeniRacun(person.zasticeniRacun || '');
    setIban(person.iban || '');
    setGlovoId((person.glovoId || person.riderID || '').trim().toLowerCase());
    setWoltId((person.woltId || '').trim().toLowerCase());
    setVozilo(person.vozilo || '');
    setVlasnik(person.vlasnik || '');
    setRegistracija(person.registracija || '');
    setFirmId(person.firmId || 'default');
    setRentaDefault(person.renta || 0);
    setRentSmjestajDefault(person.rentSmjestaj || 0);
    setOpremaDefault(person.oprema || 0);
    setAkontacijaDefault(person.akontacija || 0);
    setGorivoDefault(person.gorivo || 0);
    setOstaloDefault(person.ostalo || 0);
    setBonusDefault(person.bonus || 0);
    setAppKnjigDefault(person.appKnjig || 0);
    setDoprinosiDefault(person.doprinosi || 0);
    setFeeDefault(person.fee || 0);

    setTarifaDefault(person.tarifa || 0);
    setDepozitDefault(person.depozit || 0);
    setStrujaDefault(person.struja || 0);
    setGlovoTaxDefault(person.glovoTax || 0);
  }, [person, userPeriodData]);

  useEffect(() => {
    setStartMonth(person.startMonth || new Date().getMonth() + 1);
    setStartYear(person.startYear || new Date().getFullYear());
    setFee(userPeriodData.fee !== undefined ? userPeriodData.fee : person.fee || 0);
    setAppKnjig(userPeriodData.appKnjig !== undefined ? userPeriodData.appKnjig : person.appKnjig || 0);
    setDoprinosi(userPeriodData.doprinosi !== undefined ? userPeriodData.doprinosi : person.doprinosi || 0);
    setRenta(userPeriodData.renta !== undefined ? userPeriodData.renta : person.renta || 0);
    setRentSmjestaj(userPeriodData.rentSmjestaj !== undefined ? userPeriodData.rentSmjestaj : person.rentSmjestaj || 0);
    setOprema(userPeriodData.oprema !== undefined ? userPeriodData.oprema : person.oprema || 0);
    setAkontacija(userPeriodData.akontacija !== undefined ? userPeriodData.akontacija : person.akontacija || 0);
    setGorivo(userPeriodData.gorivo !== undefined ? userPeriodData.gorivo : person.gorivo || 0);
    setOstalo(userPeriodData.ostalo !== undefined ? userPeriodData.ostalo : person.ostalo || 0);
    setBonus(userPeriodData.bonus !== undefined ? userPeriodData.bonus : person.bonus || 0);
    setNapomena(userPeriodData.napomena !== undefined ? userPeriodData.napomena : person.napomena || '');
    setTarifa(userPeriodData.tarifa !== undefined ? userPeriodData.tarifa : person.tarifa || 0);
    setDepozit(userPeriodData.depozit !== undefined ? userPeriodData.depozit : person.depozit || 0);
    setStruja(userPeriodData.struja !== undefined ? userPeriodData.struja : person.struja || 0);
    setGlovoTax(userPeriodData.glovoTax !== undefined ? userPeriodData.glovoTax : person.glovoTax || 0);
  }, [userPeriodData, person]);

  useEffect(() => {
    setFeeAmount(calculatedFeeAmount);
  }, [calculatedFeeAmount]);

  const openReportModal = () => setIsReportModalOpen(true);
  const closeReportModal = () => setIsReportModalOpen(false);
  const openPersonModal = () => setIsPersonModalOpen(true);
  const closePersonModal = () => setIsPersonModalOpen(false);
  const openFinancialModal = () => setIsFinancialModalOpen(true);
  const closeFinancialModal = () => setIsFinancialModalOpen(false);
  const openEarningsModal = () => setIsEarningsModalOpen(true);
  const closeEarningsModal = () => {
    setEditedWeeks(new Array(numOfWeeks).fill(false));
    setEditedWoltWeeks([false, false]);
    setIsEarningsModalOpen(false);
  };

  const handleSavePerson = async () => {
    try {
      const normalizedGlovoId = glovoId.trim().toLowerCase();
      const normalizedWoltId = woltId.trim().toLowerCase();
      if (normalizedGlovoId !== (person.riderID || '').trim().toLowerCase()) {
        const riderIDQuery = query(
          collection(db, 'users'),
          where('riderID', '==', normalizedGlovoId)
        );
        const riderIDSnapshot = await getDocs(riderIDQuery);
        if (!riderIDSnapshot.empty) {
          alert('Glovo ID već postoji. Molimo unesite jedinstveni Glovo ID.');
          return;
        }
      }

      const updatedPerson = addLegacyFinancialAliases({
        ...person,
        name,
        city,
        comment,
        tekuciRacun,
        zasticeniRacun,
        iban,
        riderID: normalizedGlovoId,
        glovoId: normalizedGlovoId,
        woltId: normalizedWoltId,
        vozilo: vozilo.trim(),
        vlasnik: vlasnik.trim(),
        registracija: registracija.trim(),
        firmId,
        email: (email || '').trim().toLowerCase(),
        emailLower: (email || '').trim().toLowerCase(),
        appKnjig: appKnjigDefault,
        doprinosi: doprinosiDefault,
        fee: feeDefault,
        renta: rentaDefault,
        rentSmjestaj: rentSmjestajDefault,
        oprema: opremaDefault,
        akontacija: akontacijaDefault,
        gorivo: gorivoDefault,
        ostalo: ostaloDefault,
        bonus: bonusDefault,
        tax: glovoTaxDefault,
        rent: rentaDefault,
        petrol: gorivoDefault,
        acom: appKnjigDefault,
        utility: strujaDefault,
        sim: doprinosiDefault,
        advance: akontacijaDefault,
        startMonth,
        startYear,
      });

      updatedPerson.tarifa = tarifaDefault;
      updatedPerson.depozit = depozitDefault;
      updatedPerson.struja = strujaDefault;
      updatedPerson.glovoTax = glovoTaxDefault;

      await updateDoc(doc(db, 'users', person.id), updatedPerson);
      onUpdatePerson(updatedPerson);
      closePersonModal();
      alert('Promjene osnove osobe su uspješno spremljene!');
    } catch (e) {
      console.error('Greška pri ažuriranju korisnika:', e);
      alert('Došlo je do greške prilikom spremanja promjena. Pokušajte ponovno.');
    }
  };

  const buildReportRows = (language = 'hr') => {
    const labels = language === 'en'
      ? {
          city: 'City',
          year: 'Year',
          month: 'Month',
          period: 'Period',
          weekPrefix: 'Week',
          feeAmount: 'Fee Amount',
          fee: 'FEE',
          zaradaTotal: 'Total Earnings',
          total1: 'Total 1',
          tax: 'Tax',
          rent: 'Rent',
          petrol: 'Petrol',
          acom: 'Acom',
          utility: 'Utility',
          sim: 'Sim',
          advance: 'Advance',
          nedelja: 'Sunday Hours',
          praznici: 'Holiday Hours',
          prekovremeno: 'Overtime Hours',
          nocniSati: 'Night Hours',
          kilometri: 'Total Kilometers',
          ostalo: 'Other',
          bonus: 'Bonus',
          total2: 'Total 2',
        }
      : {
          city: 'Grad',
          year: 'Godina',
          month: 'Mjesec',
          period: 'Period',
          weekPrefix: 'Tjedan',
          feeAmount: 'Fee iznos',
          fee: 'FEE',
          zaradaTotal: 'Zarada total',
          total1: 'Total 1',
          tax: 'Tax',
          rent: 'Rent',
          petrol: 'Petrol',
          acom: 'Acom',
          utility: 'Utility',
          sim: 'Sim',
          advance: 'Advance',
          nedelja: 'Nedelja sati',
          praznici: 'Praznici sati',
          prekovremeno: 'Prekovremeni sati',
          nocniSati: 'Noćni sati',
          kilometri: 'Ukupno km',
          ostalo: 'Ostalo',
          bonus: 'Bonus',
          total2: 'Total 2',
        };

    return [
      { header: labels.city, value: person.city || 'N/A' },
      { header: labels.year, value: selectedYear },
      { header: labels.month, value: selectedMonth },
      ...Array.from({ length: numOfWeeks }, (_, i) => ({
        header: `${labels.weekPrefix} ${startWeek + i}`,
        value: parseFloat((earningsData.find(e => e.userId === person.id && e.week === (startWeek + i))?.amount || 0).toFixed(2)),
      })),
      { header: 'W1', value: parseFloat((woltEarnings[0] || 0).toFixed(2)) },
      { header: 'W2', value: parseFloat((woltEarnings[1] || 0).toFixed(2)) },
      { header: labels.zaradaTotal, value: parseFloat(zaradaTotal.toFixed(2)) },
      { header: labels.fee, value: parseFloat(fee.toFixed(2)) },
      { header: labels.feeAmount, value: parseFloat(feeAmount || 0) },
      { header: labels.total1, value: parseFloat(total1) },
      { header: labels.tax, value: parseFloat(glovoTax.toFixed(2)) },
      { header: labels.rent, value: parseFloat(renta.toFixed(2)) },
      { header: labels.petrol, value: parseFloat(gorivo.toFixed(2)) },
      { header: labels.acom, value: parseFloat(appKnjig.toFixed(2)) },
      { header: labels.utility, value: parseFloat(struja.toFixed(2)) },
      { header: labels.sim, value: parseFloat(doprinosi.toFixed(2)) },
      { header: labels.advance, value: parseFloat(akontacija.toFixed(2)) },
      { header: labels.nedelja, value: parseFloat(monthlyHoursSummary.sundayHours.toFixed(2)) },
      { header: labels.praznici, value: parseFloat(monthlyHoursSummary.holidayHours.toFixed(2)) },
      { header: labels.prekovremeno, value: parseFloat(monthlyHoursSummary.overtimeHours.toFixed(2)) },
      { header: labels.nocniSati, value: parseFloat(monthlyHoursSummary.nightHours.toFixed(2)) },
      { header: labels.kilometri, value: parseFloat(monthlyDistanceKm.toFixed(2)) },
      { header: labels.bonus, value: parseFloat(bonus.toFixed(2)) },
      { header: labels.ostalo, value: parseFloat(ostalo.toFixed(2)) },
      { header: labels.total2, value: parseFloat(total2) },
    ];
  };

  const handleSaveFinancial = async () => {
    try {
      const userPeriodQuery = query(
        collection(db, 'userPeriodData'),
        where('userId', '==', person.id),
        where('year', '==', selectedYear),
        where('month', '==', selectedMonth)
      );
      const userPeriodSnapshot = await getDocs(userPeriodQuery);

      const dataToSave = addLegacyFinancialAliases({
        fee,
        appKnjig,
        doprinosi,
        renta,
        rentSmjestaj,
        oprema,
        akontacija,
        gorivo,
        ostalo,
        bonus,
        napomena,
        zaradaTotal: zaradaTotal.toFixed(2),
        feeAmount: feeAmount,
        total1: total1,
        total2: total2,
        tax: glovoTax,
        rent: renta,
        petrol: gorivo,
        acom: appKnjig,
        utility: struja,
        sim: doprinosi,
        advance: akontacija,
        sundayAuto: toNumber(autoAmounts.sunday.toFixed(2)),
        holidayAuto: toNumber(autoAmounts.holiday.toFixed(2)),
        overtimeAuto: toNumber(autoAmounts.overtime.toFixed(2)),
        nightAuto: toNumber(autoAmounts.night.toFixed(2)),
      });

      dataToSave.tarifa = tarifa;
      dataToSave.depozit = depozit;
      dataToSave.struja = struja;
      dataToSave.glovoTax = glovoTax;

      if (!userPeriodSnapshot.empty) {
        await Promise.all(userPeriodSnapshot.docs.map((d) => updateDoc(d.ref, dataToSave)));
      } else {
        dataToSave.userId = person.id;
        dataToSave.year = selectedYear;
        dataToSave.month = selectedMonth;
        await addDoc(collection(db, 'userPeriodData'), dataToSave);
      }

      refreshData();
      closeFinancialModal();
      alert('Financijske promjene su uspješno spremljene!');
    } catch (e) {
      console.error('Greška pri ažuriranju financijskih podataka:', e);
      alert('Došlo je do greške prilikom spremanja financijskih promjena. Pokušajte ponovno.');
    }
  };

  const handleSaveEarnings = async () => {
    try {
      // Spremanje Glovo zarada (normalni tjedni)
      for (let i = 0; i < earnings.length; i++) {
        if (!editedWeeks[i]) continue;

        const weekNumber = startWeek + i;
        const amount = earnings[i];

        const earningsQuery = query(
          collection(db, 'earnings'),
          where('userId', '==', person.id),
          where('year', '==', selectedYear),
          where('month', '==', selectedMonth),
          where('week', '==', weekNumber),
          where('firmId', '==', person.firmId)
        );

        const earningsSnapshot = await getDocs(earningsQuery);

        if (!earningsSnapshot.empty) {
          const earningsDocRef = earningsSnapshot.docs[0].ref;
          const validated = validateEarningRecord({
            userId: person.id,
            year: selectedYear,
            month: selectedMonth,
            week: weekNumber,
            amount: amount,
            firmId: person.firmId,
            platform: 'glovo',
          });
          if (!validated.valid) {
            alert(validated.reason);
            continue;
          }
          await updateDoc(earningsDocRef, {
            amount: amount,
            platform: 'glovo',
          });
        } else if (amount !== 0) {
          const validated = validateEarningRecord({
            userId: person.id,
            year: selectedYear,
            month: selectedMonth,
            week: weekNumber,
            amount: amount,
            firmId: person.firmId,
            platform: 'glovo',
          });
          if (!validated.valid) {
            alert(validated.reason);
            continue;
          }
          await addDoc(collection(db, 'earnings'), validated.payload);
        }
      }

      // Spremanje Wolt zarada (W1 i W2)
      for (let i = 0; i < woltEarnings.length; i++) {
        if (!editedWoltWeeks[i]) continue;

        const woltWeek = i === 0 ? 'w1' : 'w2'; // w1 ili w2
        const amount = woltEarnings[i];

        const woltEarningsQuery = query(
          collection(db, 'earnings'),
          where('userId', '==', person.id),
          where('year', '==', selectedYear),
          where('month', '==', selectedMonth),
          where('week', '==', woltWeek),
          where('platform', '==', 'wolt')
        );

        const woltEarningsSnapshot = await getDocs(woltEarningsQuery);

        if (!woltEarningsSnapshot.empty) {
          const earningsDocRef = woltEarningsSnapshot.docs[0].ref;
          await updateDoc(earningsDocRef, {
            amount: amount,
            platform: 'wolt',
          });
        } else if (amount !== 0) {
          const validated = validateEarningRecord({
            userId: person.id,
            year: selectedYear,
            month: selectedMonth,
            week: woltWeek,
            amount: amount,
            firmId: person.firmId,
            platform: 'wolt',
          });
          if (!validated.valid) {
            alert(validated.reason);
            continue;
          }
          await addDoc(collection(db, 'earnings'), validated.payload);
        }
      }

      refreshData();
      setEditedWeeks(new Array(numOfWeeks).fill(false));
      setEditedWoltWeeks([false, false]);
      closeEarningsModal();
      alert('Zarade po tjednima su uspješno spremljene!');
    } catch (e) {
      console.error('Greška pri spremanju zarada:', e);
      alert('Došlo je do greške prilikom spremanja zarada. Pokušajte ponovno.');
    }
  };

  const handleDeleteEarning = async (weekIndex) => {
    if (window.confirm(`Jeste li sigurni da želite obrisati zaradu za tjedan ${startWeek + weekIndex}?`)) {
      try {
        const weekNumber = startWeek + weekIndex;
        const earningsQuery = query(
          collection(db, 'earnings'),
          where('userId', '==', person.id),
          where('year', '==', selectedYear),
          where('month', '==', selectedMonth),
          where('week', '==', weekNumber),
          where('firmId', '==', person.firmId)
        );

        const earningsSnapshot = await getDocs(earningsQuery);

        if (!earningsSnapshot.empty) {
          const earningsDocRef = earningsSnapshot.docs[0].ref;
          await deleteDoc(earningsDocRef);

          const updatedEarnings = [...earnings];
          updatedEarnings[weekIndex] = 0;
          setEarnings(updatedEarnings);

          const updatedEditedWeeks = [...editedWeeks];
          updatedEditedWeeks[weekIndex] = false;
          setEditedWeeks(updatedEditedWeeks);

          refreshData();
          alert(`Zarada za tjedan ${weekNumber} je uspješno obrisana!`);
        } else {
          alert(`Nema zarade za tjedan ${weekNumber} za brisanje.`);
        }
      } catch (e) {
        console.error('Greška pri brisanju zarade:', e);
        alert('Došlo je do greške prilikom brisanja zarade. Pokušajte ponovno.');
      }
    }
  };

  const handleDeleteWoltEarning = async (woltIndex) => {
    const woltWeek = woltIndex === 0 ? 'W1' : 'W2';
    if (window.confirm(`Jeste li sigurni da želite obrisati Wolt zaradu za ${woltWeek}?`)) {
      try {
        const woltWeekKey = woltIndex === 0 ? 'w1' : 'w2';
        const woltEarningsQuery = query(
          collection(db, 'earnings'),
          where('userId', '==', person.id),
          where('year', '==', selectedYear),
          where('month', '==', selectedMonth),
          where('week', '==', woltWeekKey),
          where('platform', '==', 'wolt')
        );

        const woltEarningsSnapshot = await getDocs(woltEarningsQuery);

        if (!woltEarningsSnapshot.empty) {
          const earningsDocRef = woltEarningsSnapshot.docs[0].ref;
          await deleteDoc(earningsDocRef);

          const updatedWoltEarnings = [...woltEarnings];
          updatedWoltEarnings[woltIndex] = 0;
          setWoltEarnings(updatedWoltEarnings);

          const updatedEditedWoltWeeks = [...editedWoltWeeks];
          updatedEditedWoltWeeks[woltIndex] = false;
          setEditedWoltWeeks(updatedEditedWoltWeeks);

          refreshData();
          alert(`Wolt zarada za ${woltWeek} je uspješno obrisana!`);
        } else {
          alert(`Nema Wolt zarade za ${woltWeek} za brisanje.`);
        }
      } catch (e) {
        console.error('Greška pri brisanju Wolt zarade:', e);
        alert('Došlo je do greške prilikom brisanja Wolt zarade. Pokušajte ponovno.');
      }
    }
  };

  const handleDeleteFinancialData = async () => {
    if (window.confirm('Jeste li sigurni da želite resetirati financijske podatke na zadane vrijednosti?')) {
      try {
        const userPeriodQuery = query(
          collection(db, 'userPeriodData'),
          where('userId', '==', person.id),
          where('year', '==', selectedYear),
          where('month', '==', selectedMonth)
        );
        const userPeriodSnapshot = await getDocs(userPeriodQuery);

        if (!userPeriodSnapshot.empty) {
          await Promise.all(userPeriodSnapshot.docs.map((d) => deleteDoc(d.ref)));
          setFee(person.fee || 0);
          setAppKnjig(person.appKnjig || 0);
          setDoprinosi(person.doprinosi || 0);
          setRenta(person.renta || 0);
          setRentSmjestaj(person.rentSmjestaj || 0);
          setOprema(person.oprema || 0);
          setAkontacija(person.akontacija || 0);
          setGorivo(person.gorivo || 0);
          setOstalo(person.ostalo || 0);
          setBonus(person.bonus || 0);
          setNapomena('');
          alert('Financijski podaci su resetirani na zadane vrijednosti.');
          refreshData();
        } else {
          alert('Nema financijskih podataka za brisanje.');
        }
      } catch (e) {
        console.error('Greška pri brisanju financijskih podataka:', e);
        alert('Došlo je do greške prilikom brisanja financijskih podataka. Pokušajte ponovno.');
      }
    }
  };

  const handleEarningChange = (e, weekIndex) => {
    const newAmount = parseFloat(e.target.value) || 0;
    const updatedEarnings = [...earnings];
    updatedEarnings[weekIndex] = newAmount;
    setEarnings(updatedEarnings);

    const updatedEditedWeeks = [...editedWeeks];
    updatedEditedWeeks[weekIndex] = true;
    setEditedWeeks(updatedEditedWeeks);
  };

  const handleWoltEarningChange = (e, woltIndex) => {
    const newAmount = parseFloat(e.target.value) || 0;
    const updatedWoltEarnings = [...woltEarnings];
    updatedWoltEarnings[woltIndex] = newAmount;
    setWoltEarnings(updatedWoltEarnings);

    const updatedEditedWoltWeeks = [...editedWoltWeeks];
    updatedEditedWoltWeeks[woltIndex] = true;
    setEditedWoltWeeks(updatedEditedWoltWeeks);
  };

  const getFirmName = (firmId) => {
    const firm = firms.find((firm) => firm.id === firmId);
    return firm ? firm.name : 'N/A';
  };

  const downloadExcelReport = async () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Report');
    worksheet.columns = [
      { header: 'Header', key: 'header', width: 30 },
      { header: 'Value', key: 'value', width: 20 },
    ];

    const reportData = buildReportRows('hr');

    reportData.forEach(row => worksheet.addRow(row));
    const buffer = await workbook.xlsx.writeBuffer();
    saveAs(
      new Blob([buffer], { type: 'application/octet-stream' }),
      `${person.name}_${selectedMonth}_${selectedYear}.xlsx`
    );
  };

  const downloadExcelReportEN = async () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Report');
    worksheet.columns = [
      { header: 'Header', key: 'header', width: 30 },
      { header: 'Value', key: 'value', width: 20 },
    ];

    const reportDataEN = buildReportRows('en');

    reportDataEN.forEach(row => worksheet.addRow(row));
    const buffer = await workbook.xlsx.writeBuffer();
    saveAs(
      new Blob([buffer], { type: 'application/octet-stream' }),
      `${person.name}_${selectedMonth}_${selectedYear}_EN.xlsx`
    );
  };

  const downloadPDFReport = () => {
    const doc = new jsPDF('portrait', 'pt', 'A4');
    const margin = 40;
    const reportData = buildReportRows('hr').map((row) => [row.header, row.value]);

    doc.autoTable({
      startY: margin,
      head: [['Header', 'Value']],
      body: reportData,
      theme: 'grid',
      styles: { fontSize: 10, cellPadding: 5, valign: 'middle', halign: 'center' },
      headStyles: { fillColor: [245, 245, 220], textColor: 0, fontStyle: 'bold' },
    });
    doc.save(`${person.name}_${selectedMonth}_${selectedYear}.pdf`);
  };

  const downloadPDFReportEN = () => {
    const doc = new jsPDF('portrait', 'pt', 'A4');
    const margin = 40;
    const reportDataEN = buildReportRows('en').map((row) => [row.header, row.value]);

    doc.autoTable({
      startY: margin,
      head: [['Header', 'Value']],
      body: reportDataEN,
      theme: 'grid',
      styles: { fontSize: 10, cellPadding: 5, valign: 'middle', halign: 'center' },
      headStyles: { fillColor: [245, 245, 220], textColor: 0, fontStyle: 'bold' },
    });
    doc.save(`${person.name}_${selectedMonth}_${selectedYear}_EN.pdf`);
  };

  const printReport = () => {
    const printWindow = window.open('', '_blank');
    const documentContent = `
      <html>
        <head>
          <style>
            body { font-family: Arial, sans-serif; padding: 20px; }
            table { width: 80%; margin: 20px auto; border-collapse: collapse; margin-top: 20px; }
            th, td { border: 1px solid black; padding: 12px; text-align: center; }
            th { background-color: #F5F5DC; font-weight: bold; font-size: 18px; }
            td { font-size: 16px; }
          </style>
        </head>
        <body>
          <h2 style="text-align: center;"></h2>
          <table>
            <tr><th>Header</th><th>Value</th></tr>
            ${buildReportRows('hr').map(row => `<tr><td>${row.header}</td><td>${typeof row.value === 'number' ? row.value.toFixed(2) : row.value}</td></tr>`).join('')}
          </table>
        </body>
      </html>
    `;
    printWindow.document.write(documentContent);
    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
  };

  const printReportEN = () => {
    const printWindow = window.open('', '_blank');
    const documentContent = `
      <html>
        <head>
          <style>
            body { font-family: Arial, sans-serif; padding: 20px; }
            table { width: 80%; margin: 20px auto; border-collapse: collapse; margin-top: 20px; }
            th, td { border: 1px solid black; padding: 12px; text-align: center; }
            th { background-color: #F5F5DC; font-weight: bold; font-size: 18px; }
            td { font-size: 16px; }
          </style>
        </head>
        <body>
          <h2 style="text-align: center;"></h2>
          <table>
            <tr><th>Header</th><th>Value</th></tr>
            ${buildReportRows('en').map(row => `<tr><td>${row.header}</td><td>${typeof row.value === 'number' ? row.value.toFixed(2) : row.value}</td></tr>`).join('')}
          </table>
        </body>
      </html>
    `;
    printWindow.document.write(documentContent);
    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
  };

  const handleReportOption = async (format) => {
    console.log(format);
    let language = 'hr';
    if (format.endsWith('-en')) {
      language = 'en';
      format = format.slice(0, -3);
    }

    switch (format) {
      case 'xlsx':
        if (language === 'hr') await downloadExcelReport();
        else if (language === 'en') await downloadExcelReportEN();
        break;
      case 'pdf':
        if (language === 'hr') downloadPDFReport();
        else if (language === 'en') downloadPDFReportEN();
        break;
      case 'print':
        if (language === 'hr') printReport();
        else if (language === 'en') printReportEN();
        break;
      default:
        break;
    }
  };

  const handleArchive = async () => {
    if (window.confirm(`Jeste li sigurni da želite arhivirati ${person.name}?`)) {
      try {
        const archiveMonth = selectedMonth;
        const archiveYear = selectedYear;
        await updateDoc(doc(db, 'users', person.id), {
          archived: true,
          archiveMonth,
          archiveYear,
        });
        onUpdatePerson({ ...person, archived: true, archiveMonth, archiveYear });
        closePersonModal();
        closeFinancialModal();
        alert('Osoba uspješno arhivirana!');
      } catch (e) {
        console.error('Greška pri arhiviranju korisnika:', e);
        alert('Došlo je do greške prilikom arhiviranja korisnika. Pokušajte ponovno.');
      }
    }
  };

  return (
    <>
      <tr>
        <td className={isRowSelected ? 'selected-cell' : ''} onClick={() => setIsRowSelected(!isRowSelected)}>
          <Tooltip content={person.comment || ''} imageUrl={person.imageUrl || null}>
            {person.name}
          </Tooltip>
        </td>
        <td className={isRowSelected ? 'selected-cell' : ''}>
          <button className="edit-button" onClick={openReportModal} title="Report">
            <FaDownload /> Izvještaj
          </button>
          <button className="edit-button" onClick={openPersonModal} title="Uredi osobu">
            <FaEdit /> Uredi
          </button>
          <button className="edit-button" onClick={openFinancialModal} title="Uredi financije">
            <FaEdit /> Finan
          </button>
        </td>
        <td className={`${isRowSelected ? 'selected-cell' : ''} ${hiddenColumns.glovoId ? 'hidden-column' : ''}`}>{person.glovoId || person.riderID || '-'}</td>
        <td className={`${isRowSelected ? 'selected-cell' : ''} ${hiddenColumns.woltId ? 'hidden-column' : ''}`}>{person.woltId || '-'}</td>
        <td className={`${isRowSelected ? 'selected-cell' : ''} ${hiddenColumns.vozilo ? 'hidden-column' : ''}`}>{person.vozilo || '-'}</td>
        <td className={`${isRowSelected ? 'selected-cell' : ''} ${hiddenColumns.registracija ? 'hidden-column' : ''}`}>{person.registracija || '-'}</td>
        <td className={`${isRowSelected ? 'selected-cell' : ''} ${hiddenColumns.vlasnik ? 'hidden-column' : ''}`}>{person.vlasnik || '-'}</td>
        <td className={`${isRowSelected ? 'selected-cell' : ''} ${hiddenColumns.firma ? 'hidden-column' : ''}`}>{getFirmName(person.firmId)}</td>
        {earnings.map((earning, index) => (
          <td className={isRowSelected ? 'selected-cell' : ''} key={index}>{earning.toFixed(2)}</td>
        ))}
        {/* W1 i W2 stupci */}
        <td className={isRowSelected ? 'selected-cell' : ''}>{woltEarnings[0].toFixed(2)}</td>
        <td className={isRowSelected ? 'selected-cell' : ''}>{woltEarnings[1].toFixed(2)}</td>
        <td className={`${isRowSelected ? 'selected-cell' : ''} ${hiddenColumns.zaradaTotal ? 'hidden-column' : ''}`}>{zaradaTotal.toFixed(2)}</td>
        <td className={`${isRowSelected ? 'selected-cell' : ''} ${hiddenColumns.fee ? 'hidden-column' : ''}`}>{fee}%</td>
        <td className={`${isRowSelected ? 'selected-cell' : ''} ${hiddenColumns.feeIznos ? 'hidden-column' : ''}`}>{feeAmount}</td>
        <td className={`${isRowSelected ? 'selected-cell' : ''} ${hiddenColumns.total1 ? 'hidden-column' : ''}`}>{total1.toFixed(2)}</td>
        <td className={`${isRowSelected ? 'selected-cell' : ''} ${hiddenColumns.tax ? 'hidden-column' : ''}`}>{glovoTax.toFixed(2)}</td>
        <td className={`${isRowSelected ? 'selected-cell' : ''} ${hiddenColumns.rent ? 'hidden-column' : ''}`}>{renta.toFixed(2)}</td>
        <td className={`${isRowSelected ? 'selected-cell' : ''} ${hiddenColumns.petrol ? 'hidden-column' : ''}`}>{gorivo.toFixed(2)}</td>
        <td className={`${isRowSelected ? 'selected-cell' : ''} ${hiddenColumns.acom ? 'hidden-column' : ''}`}>{appKnjig.toFixed(2)}</td>
        <td className={`${isRowSelected ? 'selected-cell' : ''} ${hiddenColumns.utility ? 'hidden-column' : ''}`}>{struja.toFixed(2)}</td>
        <td className={`${isRowSelected ? 'selected-cell' : ''} ${hiddenColumns.sim ? 'hidden-column' : ''}`}>{doprinosi.toFixed(2)}</td>
        <td className={`${isRowSelected ? 'selected-cell' : ''} ${hiddenColumns.advance ? 'hidden-column' : ''}`}>{akontacija.toFixed(2)}</td>
        <td className={`${isRowSelected ? 'selected-cell' : ''} ${hiddenColumns.nedelja ? 'hidden-column' : ''}`}>{autoAmounts.sunday.toFixed(2)}</td>
        <td className={`${isRowSelected ? 'selected-cell' : ''} ${hiddenColumns.praznici ? 'hidden-column' : ''}`}>{autoAmounts.holiday.toFixed(2)}</td>
        <td className={`${isRowSelected ? 'selected-cell' : ''} ${hiddenColumns.prekovremeno ? 'hidden-column' : ''}`}>{autoAmounts.overtime.toFixed(2)}</td>
        <td className={`${isRowSelected ? 'selected-cell' : ''} ${hiddenColumns.nocniSati ? 'hidden-column' : ''}`}>{autoAmounts.night.toFixed(2)}</td>
        <td className={`${isRowSelected ? 'selected-cell' : ''} ${hiddenColumns.bonus ? 'hidden-column' : ''}`}>{bonus.toFixed(2)}</td>
        <td className={`${isRowSelected ? 'selected-cell' : ''} ${hiddenColumns.ostalo ? 'hidden-column' : ''}`}>{ostalo.toFixed(2)}</td>
        <td className={`${isRowSelected ? 'selected-cell' : ''} ${hiddenColumns.total2 ? 'hidden-column' : ''}`}>{total2}</td>
      </tr>

      <ReportModal 
        isOpen={isReportModalOpen} 
        onRequestClose={closeReportModal} 
        onGenerateReport={handleReportOption} 
      />

      <Modal
        isOpen={isPersonModalOpen}
        onRequestClose={closePersonModal}
        className="modal"
        overlayClassName="overlay"
      >
        <h2>Uredi osobu</h2>
        <form className="edit-person-form">
          <div className="form-group">
            <label>Ime:</label>
            <input type="text" value={name} onChange={(e) => setName(e.target.value)} />
          </div>
          <div className="form-group">
            <label>Email:</label>
            <input type="text" value={email} onChange={(e) => setEmail(e.target.value)} />
          </div>
          <div className="form-group">
            <label>Firma:</label>
            <select value={firmId} onChange={(e) => setFirmId(e.target.value)} required>
              <option value="default">Default</option>
              {firms.filter((firm) => firm.id !== 'default').map((firm) => (
                <option key={firm.id} value={firm.id}>{firm.name}</option>
              ))}
            </select>
          </div>
          <div className="form-group">
            <label>Glovo ID:</label>
            <input type="text" value={glovoId} onChange={(e) => setGlovoId(e.target.value)} required />
          </div>
          <div className="form-group">
            <label>Wolt ID:</label>
            <input type="text" value={woltId} onChange={(e) => setWoltId(e.target.value)} />
          </div>
          <div className="person-extra-section">
            <h3 className="person-extra-section-title">Podaci o vozilu</h3>
            <div className="form-group">
              <label>VOZILO:</label>
              <input type="text" value={vozilo} onChange={(e) => setVozilo(e.target.value)} />
            </div>
            <div className="form-group">
              <label>VLASNIK:</label>
              <input type="text" value={vlasnik} onChange={(e) => setVlasnik(e.target.value)} />
            </div>
            <div className="form-group">
              <label>REGISTRACIJA:</label>
              <input
                type="text"
                value={registracija}
                onChange={(e) => setRegistracija(e.target.value)}
              />
            </div>
          </div>
          <div className="form-group">
            <label>IBAN:</label>
            <input type="text" value={iban} onChange={(e) => setIban(e.target.value)} />
          </div>
          <div className="form-group">
            <label>Početni mjesec rada:</label>
            <select value={startMonth} onChange={(e) => setStartMonth(parseInt(e.target.value))}>
              {[...Array(12)].map((_, i) => (
                <option key={i + 1} value={i + 1}>{i + 1}</option>
              ))}
            </select>
          </div>
          <div className="form-group">
            <label>Početna godina rada:</label>
            <select value={startYear} onChange={(e) => setStartYear(parseInt(e.target.value))}>
              {Array.from({ length: new Date().getFullYear() + 1 - 2022 + 1 }, (_, i) => 2022 + i).map((year) => (
                <option key={year} value={year}>{year}</option>
              ))}
            </select>
          </div>
          <div className="form-group">
            <label>Acom (default):</label>
            <input
              type="number"
              value={appKnjigDefault}
              onChange={(e) => setAppKnjigDefault(parseFloat(e.target.value) || 0)}
            />
          </div>
          <div className="form-group">
            <label>Sim (default):</label>
            <input
              type="number"
              value={doprinosiDefault}
              onChange={(e) => setDoprinosiDefault(parseFloat(e.target.value) || 0)}
            />
          </div>
          <div className="form-group">
            <label>Fee % (default):</label>
            <input
              type="number"
              value={feeDefault}
              onChange={(e) => setFeeDefault(parseFloat(e.target.value) || 0)}
              min="0"
              max="100"
            />
          </div>
          <div className="form-group">
            <label>Tax (default):</label>
            <input
              type="number"
              value={glovoTaxDefault}
              onChange={(e) => setGlovoTaxDefault(parseFloat(e.target.value) || 0)}
            />
          </div>
          <div className="form-group">
            <label>Rent (default):</label>
            <input
              type="number"
              value={rentaDefault}
              onChange={(e) => setRentaDefault(parseFloat(e.target.value) || 0)}
            />
          </div>
          <div className="form-group">
            <label>Petrol (default):</label>
            <input
              type="number"
              value={gorivoDefault}
              onChange={(e) => setGorivoDefault(parseFloat(e.target.value) || 0)}
            />
          </div>
          <div className="form-group">
            <label>Utility (default):</label>
            <input
              type="number"
              value={strujaDefault}
              onChange={(e) => setStrujaDefault(parseFloat(e.target.value) || 0)}
            />
          </div>
          <div className="form-group">
            <label>Advance (default):</label>
            <input
              type="number"
              value={akontacijaDefault}
              onChange={(e) => setAkontacijaDefault(parseFloat(e.target.value) || 0)}
            />
          </div>
          <div className="form-group">
            <label>Ostalo (default):</label>
            <input
              type="number"
              value={ostaloDefault}
              onChange={(e) => setOstaloDefault(parseFloat(e.target.value) || 0)}
            />
          </div>
          <div className="form-group">
            <label>Bonus (default):</label>
            <input
              type="number"
              value={bonusDefault}
              onChange={(e) => setBonusDefault(parseFloat(e.target.value) || 0)}
            />
          </div>
          <div className="button-group">
            <button type="button" className="save-button" onClick={handleSavePerson}>Spremi</button>
            <button type="button" className="cancel-button" onClick={closePersonModal}>Odustani</button>
            <button type="button" className="delete-button" onClick={handleArchive}>Arhiviraj</button>
          </div>
        </form>
      </Modal>

      <Modal
        isOpen={isFinancialModalOpen}
        onRequestClose={closeFinancialModal}
        className="modal"
        overlayClassName="overlay"
      >
        <h2>Finan</h2>
        <form className="edit-person-form">
          <div className="form-group">
            <label>Fee %:</label>
            <input
              type="number"
              value={fee}
              onChange={(e) => setFee(parseFloat(e.target.value) || 0)}
              min="0"
              max="100"
            />
          </div>
          <div className="form-group">
            <label>Acom:</label>
            <input
              type="number"
              value={appKnjig}
              onChange={(e) => setAppKnjig(parseFloat(e.target.value) || 0)}
            />
          </div>
          <div className="form-group">
            <label>Sim:</label>
            <input
              type="number"
              value={doprinosi}
              onChange={(e) => setDoprinosi(parseFloat(e.target.value) || 0)}
            />
          </div>
          <div className="form-group">
            <label>Tax:</label>
            <input
              type="number"
              value={glovoTax}
              onChange={(e) => setGlovoTax(parseFloat(e.target.value) || 0)}
            />
          </div>
          <div className="form-group">
            <label>Rent:</label>
            <input
              type="number"
              value={renta}
              onChange={(e) => setRenta(parseFloat(e.target.value) || 0)}
            />
          </div>
          <div className="form-group">
            <label>Petrol:</label>
            <input
              type="number"
              value={gorivo}
              onChange={(e) => setGorivo(parseFloat(e.target.value) || 0)}
            />
          </div>
          <div className="form-group">
            <label>Utility:</label>
            <input
              type="number"
              value={struja}
              onChange={(e) => setStruja(parseFloat(e.target.value) || 0)}
            />
          </div>
          <div className="form-group">
            <label>Advance:</label>
            <input
              type="number"
              value={akontacija}
              onChange={(e) => setAkontacija(parseFloat(e.target.value) || 0)}
            />
          </div>
          <div className="form-group">
            <label>Ostalo:</label>
            <input
              type="number"
              value={ostalo}
              onChange={(e) => setOstalo(parseFloat(e.target.value) || 0)}
            />
          </div>
          <div className="form-group">
            <label>Bonus:</label>
            <input
              type="number"
              value={bonus}
              onChange={(e) => setBonus(parseFloat(e.target.value) || 0)}
            />
          </div>
          <div className="form-group">
            <label>Napomena:</label>
            <input
              type="text"
              value={napomena}
              onChange={(e) => setNapomena(e.target.value)}
            />
          </div>
          <div className="form-group">
            <button type="button" className="edit-button" onClick={openEarningsModal} title="Uredi zarade">
              <FaEdit /> Uredi zarade po tjednima
            </button>
          </div>
          <div className="button-group">
            <button type="button" className="save-button" onClick={handleSaveFinancial}>Spremi</button>
            <button type="button" className="cancel-button" onClick={closeFinancialModal}>Odustani</button>
            <button type="button" className="delete-button" onClick={handleDeleteFinancialData}>
              Resetiraj na zadane vrijednosti
            </button>
          </div>
        </form>
      </Modal>

      <Modal
        isOpen={isEarningsModalOpen}
        onRequestClose={closeEarningsModal}
        className="modal"
        overlayClassName="overlay"
      >
        <h2>Uredi zarade po tjednima</h2>
        <form className="edit-person-form">
          <h3 style={{ marginBottom: '15px', color: '#667eea' }}>Glovo zarade</h3>
          {[...Array(numOfWeeks)].map((_, i) => {
            const weekNumber = startWeek + i;
            return (
              <div className="form-group" key={i} style={{ display: 'flex', alignItems: 'center' }}>
                <label style={{ flex: '1', marginRight: '10px' }}>Tjedan {weekNumber}:</label>
                <input
                  type="number"
                  value={earnings[i]}
                  onChange={(e) => handleEarningChange(e, i)}
                  style={{ flex: '2', marginRight: '10px' }}
                />
                <button
                  type="button"
                  className="delete-button"
                  onClick={() => handleDeleteEarning(i)}
                  title="Obriši zaradu"
                  style={{ padding: '5px 10px', fontSize: '14px' }}
                >
                  <FaTrash />
                </button>
              </div>
            );
          })}
          {/* Wolt zarade - W1 i W2 */}
          <div style={{ marginTop: '20px', paddingTop: '20px', borderTop: '2px solid #e9ecef' }}>
            <h3 style={{ marginBottom: '15px', color: '#667eea' }}>Wolt zarade</h3>
            {[0, 1].map((woltIndex) => (
              <div className="form-group" key={`wolt-${woltIndex}`} style={{ display: 'flex', alignItems: 'center' }}>
                <label style={{ flex: '1', marginRight: '10px' }}>W{woltIndex + 1} (Wolt):</label>
                <input
                  type="number"
                  value={woltEarnings[woltIndex]}
                  onChange={(e) => handleWoltEarningChange(e, woltIndex)}
                  style={{ flex: '2', marginRight: '10px' }}
                />
                <button
                  type="button"
                  className="delete-button"
                  onClick={() => handleDeleteWoltEarning(woltIndex)}
                  title="Obriši Wolt zaradu"
                  style={{ padding: '5px 10px', fontSize: '14px' }}
                >
                  <FaTrash />
                </button>
              </div>
            ))}
          </div>
          <div className="button-group">
            <button type="button" className="save-button" onClick={handleSaveEarnings}>Spremi</button>
            <button type="button" className="cancel-button" onClick={closeEarningsModal}>Odustani</button>
          </div>
        </form>
      </Modal>
    </>
  );
}

export default PersonRow;